var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('McButtonBack',{staticClass:"mt-2 me-3 mb-4 float-end",attrs:{"href":"/report","query":{ domain: 'fleet' }}}),(!_vm.isLoading)?_c('CustomReport',{attrs:{"id":_vm.uuid,"link":_vm.link}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }